var render = function render(_c,_vm){return _c('div',{staticClass:"card-array__wrapper"},[_c(_vm.$options.components.FunctionalFormulaArrayItems,{tag:"component",staticClass:"card-array",class:_vm.data.staticClass || '',attrs:{"field":_vm.props.field,"value":_vm.props.value,"selected":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }